import {apiPostAuth, apiDeleteAuth, apiGetAuth, apiPutAuth} from '@/utils/api'
import { API_USER_MANAGEMENT, API_CAMPAIGN, API_CONSUMER } from '@/utils/api-url'
import router from '@/router'

import {
  notificationDanger
} from '@/utils/notification'

const state = () => {
  return {
    detail_approval_message: { data: []},
    detail_user: { data: []},
    tags: { data: [] },
    campaigns: { data: [] },
    push_messages: { data: [] },
    detail_push_messages: { data: {}},
    meta_filter: {},
    data_modal_add_edit: {},
    toggle_modal_add_edit_discard: {
      targetModals: false,
      title: '',
      description: '',
      customTitleBtnOk: '',
      customClass: '',
      type: '',
      loadingTable: false,
      loadingPopUp: false
    }
  }
}

const mutations = {
  SET_LIST_APPROVAL_MESSAGE (state, payload) {
    state.detail_approval_message = payload
  },
  SET_DETAIL_USER (state, payload) {
    state.detail_user = payload
  },
  SET_PUSH_MESSAGE (state, payload) {
    state.push_messages = payload
  },
  SET_DETAIL_PUSH_MESSAGE (state, payload) {
    state.detail_push_messages = payload
  },
  SET_DATA_MODAL_ADD_EDIT (state, payload) {
    state.data_modal_add_edit = payload
  },
  SET_TOGGLE_MODAL_ADD_EDIT_DISCARD (state, payload) {
    state.toggle_modal_add_edit_discard = payload
  },
  SET_META_FILTER (state, payload) {
    state.meta_filter = payload
  }
}

const actions = {
  async getListApprovalMessage (context, payload) {
    try {
      const response = await apiGetAuth(API_CONSUMER.LIST_APPROVAL_MESSAGE, payload)
      context.commit('SET_LIST_APPROVAL_MESSAGE', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async getListAllDetailUser (context, payload) {
    try {
      const response = await apiPostAuth(API_USER_MANAGEMENT.ALL_USERNAME, payload)
      context.commit('SET_DETAIL_USER', response.data.data)
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,  
        title: '', 
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async getListPushMessage(context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.LIST_PUSH_MESSAGE, payload)
      context.commit('SET_PUSH_MESSAGE', response.data.data)
      context.commit('SET_META_FILTER', payload)
      router.push({name: 'PushMessages', query: payload})
    } catch (error) {
      notificationDanger(error)
    }
  },
  async createPushMessage (context, payload) {
    try {
      const response = await apiPostAuth(API_CAMPAIGN.CREATE_PUSH_MESSAGE, payload)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async updatePushMessage (context, payload) {
    try {
      const response = await apiPutAuth(API_CAMPAIGN.UPDATE_PUSH_MESSAGE(payload.id), payload.reqBody)
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  },
  async getDetailPushMessage (context, payload) {
    try {
      const response = await apiGetAuth(API_CAMPAIGN.DETAIL_PUSH_MESSAGE(payload))
      context.commit('SET_DETAIL_PUSH_MESSAGE', response.data.data)
    } catch (error) {
      notificationDanger(error)
    }
  },
  async deletePushMessage (context, payload) {
    try {
      const response = await apiDeleteAuth(API_CAMPAIGN.DELETE_PUSH_MESSAGE(payload))
      return response.data
    } catch (error) {
      context.commit('SET_TOGGLE_MODAL_ADD_EDIT_DISCARD', {
        targetModals: false,
        title: '',
        description: '',
        customTitleBtnOk: '',
        customClass: '',
        type: '',
        loadingTable: false,
        loadingPopUp: false
      })
      notificationDanger(error)
    }
  }
}

const getters = {
  detail_approval_message (state) {
    return state.detail_approval_message
  },
  detail_user (state) {
    return state.detail_user
  },
  list_push_message (state) {
    return state.push_messages
  },
  detail_push_messages (state) {
    return state.detail_push_messages
  },
  get_data_modal_add_edit (state) {
    return state.data_modal_add_edit
  },
  get_toggle_modal_add_edit_discard (state) {
    return state.toggle_modal_add_edit_discard
  },
  meta_filter (state) {
    return state.meta_filter
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
